<div class="reset-password-page-container">
  <app-reset-password class="z-index--1"></app-reset-password>
  <app-circles-background class="circle-background"></app-circles-background>
</div>
